import React from 'react';

class NumericCellEdit extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.toFloatValue(props.value),
			updated: false
		};
	}

	static defaultProps = {
		value: 0.0
	};

	toFloatValue = number => `${parseFloat(number).toFixed(2)}` || '0.00';

	getValue = () => this.toFloatValue(this.number.value);

	onBlur = () => {
		const { onUpdate } = this.props.editorProps;
		const value = this.getValue();
		this.setState({ value, updated: true }, () => onUpdate(value));
	};

	componentDidMount() {
		const { row, col, rowIndex, columnIndex, onStartEdit } = this.props;
		if (typeof onStartEdit === 'function') {
			onStartEdit(row, col, rowIndex, columnIndex);
		}
	}

	componentWillUnmount() {
		const { onUpdate } = this.props.editorProps;
		const { value, updated } = this.state;
		if (!updated) {
			onUpdate(value);
		}
	}

	render() {
		const { onUpdate, didMount, ...rest } = this.props.editorProps;
		const { value } = this.state;

		return (
			<input
				{...rest}
				key="numeric"
				defaultValue={value}
				ref={node => (this.number = node)}
				type="number"
				min="0.00"
				max="999.99"
				step="0.01"
				onBlur={this.onBlur}
			/>
		);
	}
}
export default NumericCellEdit;
